import { createContext, ReactNode, useContext } from "react";
import { IncomingMessage, ServerResponse } from 'http'
import { getCookie as getCookieClient } from "../../lib/controllers/common/cookies/get";
import { setCookie } from 'cookies-next';
import { v4 as uuidv4 } from 'uuid';

const logProject = process.env['LOG_PROJECT'] || 'ecosystem-non-prod';

export type RequestContextType = {
  path: string,
  method: string,
  correlationId: string
} | undefined

export type ServiceProviderPropType = {
    requestContext: RequestContextType
    children: ReactNode;
  }

export const LoggingContext = createContext<RequestContextType>(undefined);

export const LoggingContextProvider: React.FC<ServiceProviderPropType> = ({ requestContext, children }) => {

    let context  = requestContext;
    
    const cookie = getCookieClient({ key: 'requestContext' });
    if (cookie && cookie.length) {
      context = JSON.parse(cookie);
      if (context && context.correlationId) {
        localStorage.setItem('correlationId', context.correlationId)
      }
    }

    return (
      <LoggingContext.Provider value={context}>
        {children}
      </LoggingContext.Provider>
    )
}

export function useLoggingContext(): RequestContextType {
    return useContext(LoggingContext);
}

export const getRequestContext = (
  req: IncomingMessage | undefined,
  res: ServerResponse | undefined,
): RequestContextType => {
  if (typeof window === 'undefined' && req && req.url && res) {
    let correlationId = req.headers['x-cloud-trace-context'] as string || uuidv4();
    const path = req.url;
    if (typeof correlationId === 'string' && correlationId.includes('/')) {
        const [trace] = correlationId.split('/');
        correlationId = trace;
    }
    const context =  {
      correlationId,
      method: req.method || '',
      path: path || '',
    }

    const trace = `projects/${logProject}/traces/${correlationId}`;

    const entry = {
      message: `APRIME - visit: ${context.path}`,
      logName: `APRIME`,
      severity: 'info',
      correlationId: context.correlationId,
      "logging.googleapis.com/trace": trace,
    };
    console.log(JSON.stringify(entry));

    setCookie('requestContext', context, { req, res, maxAge: 60 * 60 * 24 });
    return context;
  }
  return undefined
}